/* eslint-disable react/prop-types */
import { Divider } from "@mui/material";
import ModalUI from "components/ModalUI";
import ghollakProfitCalculationStatus from "enums/ghollakProfitCalculationStatus";
import React from 'react'
import separate from "utils/separate";

export default function ProfitDetailModal({ modalInfo, closeModal }) {
    return (
        <ModalUI open={modalInfo.state} handleClose={closeModal} style={{ minWidth: "600px" }}>
            <section style={{ fontSize: 16 }}>
                <p>نرخ سود محاسبه شده: {modalInfo.item?.rate}</p>
                <p>درصد سهم پلتفرم: {modalInfo.item?.platform_cut}</p>
                <p>درصد سهم کاربر: {modalInfo.item?.user_cut}</p>
                <Divider style={{ margin: "0.7rem 0" }} />
                <p>موجودی فرصت: {separate(modalInfo.item?.base_amount)}</p>
                <p>سود ناخالص: {separate(modalInfo.item?.gross_profit_amount)}</p>
                <p>سهم پلتفرم: {separate(modalInfo.item?.platform_fee_amount)}</p>
                <p>سود کاربر: {separate(modalInfo.item?.user_profit_amount)}</p>
                <Divider style={{ margin: "0.7rem 0" }} />
                <p>وضعیت: {ghollakProfitCalculationStatus(modalInfo.item?.status)}</p>
                <p>تاریخ محاسبه: {new Date(modalInfo.item?.calculated_at).toLocaleString("fa-IR")}</p>
                {modalInfo.item?.sent_for_payout_at && <p>تاریخ ارسال برای پرداخت: {new Date(modalInfo.item?.sent_for_payout_at).toLocaleString("fa-IR")}</p>}
                {modalInfo.item?.paid_at && <p>تاریخ پرداخت: {new Date(modalInfo.item?.paid_at).toLocaleString("fa-IR")}</p>}
            </section>
        </ModalUI>
    )
}
